// SEO Configuration
// Update this file to modify SEO settings across the site

export const seoConfig = {
  siteName: "Tushar Singh - Portfolio",
  defaultKeywords: "Tushar Singh, Full-Stack Developer, React Developer, React Native, Node.js, Web3, JavaScript, TypeScript, Software Engineer, Noida",
  defaultTitle: "Tushar Singh - Full-Stack Developer | React & React Native Expert",
  defaultDescription: "Experienced Full-Stack Developer with 12+ years of expertise in React, React Native, Node.js, and Web3. Building scalable applications and solving complex problems. Based in Noida, India.",
  siteUrl: "https://tusharsingh.me",
  defaultImage: "/assets/img/profile.jpeg",
  defaultImageAlt: "Portrait of Tushar Singh, Full-Stack Developer",
  locale: "en_US",
  twitterHandle: "@tusharsingh1991",
  
  // Page-specific SEO
  pages: {
    home: {
      title: "Tushar Singh - Full-Stack Developer | React & React Native Expert",
      description: "Experienced Full-Stack Developer with 12+ years of expertise in React, React Native, Node.js, and Web3. Building scalable applications and solving complex problems.",
      keywords: ["Full-Stack Developer", "React Developer", "React Native", "Node.js", "JavaScript", "TypeScript", "Web3", "Tushar Singh"]
    },
    projects: {
      title: "Projects - Tushar Singh",
      description: "Explore my portfolio of enterprise applications, mobile apps, and fintech platforms built with modern technologies.",
      keywords: ["Projects", "Portfolio", "React Projects", "Mobile Apps", "Enterprise Applications"]
    },
    experience: {
      title: "Experience - Tushar Singh",
      description: "12+ years of professional experience in software development, from Android apps to enterprise solutions.",
      keywords: ["Work Experience", "Software Engineer", "Project Lead", "Career"]
    },
    contact: {
      title: "Contact - Tushar Singh",
      description: "Get in touch with me for opportunities, collaborations, or just to say hello.",
      keywords: ["Contact", "Hire Developer", "Freelance", "Collaboration"]
    },
    resources: {
      title: "Resources - Tushar Singh | Development Guides & Tools",
      description: "Tutorials, code snippets, and curated software engineering resources from Tushar Singh.",
      keywords: ["Developer Resources", "Programming Guides", "Code Snippets", "Software Engineering", "Tushar Singh"]
    },
    privacyPolicy: {
      title: "Privacy Policy - Tushar Singh",
      description: "Privacy policy for tusharsingh.me detailing data usage, retention, and contact information.",
      keywords: ["Privacy Policy", "Data Protection", "Tushar Singh"]
    }
  }
};

export default seoConfig;
